module.exports = __webpack_public_path__ + "img/orange.cd69ca6a.svg";